import React from "react";
import Reveal from "./Reveal";
import { TESTIMONIALS } from "../mock";

const Testimonials = () => {
  return (
    <section
      id="testimonials"
      data-testid="testimonials-section"
      className="bg-white text-[#18324F] py-24 lg:py-32"
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-12">
        <Reveal>
          <p className="uppercase tracking-[0.3em] text-xs font-normal text-[#B88A3B]">
            Testimonials
          </p>
          <h2 className="font-serif-lux font-light text-4xl sm:text-5xl lg:text-6xl leading-[1.05] tracking-tight mt-6 max-w-2xl">
            In their <span className="italic text-[#B88A3B]">own words</span>
          </h2>
        </Reveal>
        <div className="grid md:grid-cols-3 gap-10 mt-16">
          {TESTIMONIALS.map((t, i) => (
            <Reveal key={t.name} delay={i * 0.1}>
              <figure className={`border-l-2 border-[#B88A3B] pl-8 py-2 ${i === 1 ? "md:mt-14" : ""}`}>
                <span className="font-serif-lux text-6xl text-[#B88A3B]/40 leading-none block mb-4">
                  “
                </span>
                <blockquote className="font-serif-lux text-xl md:text-2xl leading-snug italic text-[#18324F]/85">
                  {t.quote}
                </blockquote>
                <figcaption className="mt-8">
                  <p className="uppercase tracking-[0.2em] text-sm font-normal">
                    {t.name}
                  </p>
                  <p className="text-xs text-[#18324F]/50 mt-1 uppercase tracking-[0.2em]">
                    {t.location}
                  </p>
                </figcaption>
              </figure>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Testimonials;
